// extracted by mini-css-extract-plugin
export var columnItem = "_fd-3";
export var columnItemDraggable = "_fd-5";
export var dragHandle = "_fd-0";
export var dragHandleHovered = "_fd-1";
export var dropdown = "_fd-6";
export var dropdownContent = "_fd-8";
export var dropdownInner = "_fd-7";
export var filterDropdownHeader = "_fd-9";
export var icon = "_fd-2";
export var moveToTopButton = "_fd-4";
export var sectionDivider = "_fd-a";